import { createSelector } from 'reselect'

import { selectCockpitMode } from './selectCockpitMode'
import { selectCockpitOfferingsCatalog } from './selectCockpitOfferingsCatalog'
import { selectVisibleCockpitPartnerData } from './selectVisibleCockpitPartnerData'

export const selectVisibleCockpitOfferingsCatalog = createSelector(
  [selectCockpitMode, selectCockpitOfferingsCatalog, selectVisibleCockpitPartnerData],
  (cockpitMode, offeringsCatalog, visiblePartners) => {
    if (cockpitMode === 'partner') {
      return offeringsCatalog
    }

    const partnerIds = new Set(visiblePartners.map(({ PartnerId }) => PartnerId))
    return offeringsCatalog.filter(({ partnerId }) => partnerIds.has(partnerId))
  }
)
